module.exports = __webpack_public_path__ + "img/bsp_cat_1.7e634dcb.jpg";